import type ILegReport from '../../../models/pa-egna-ben/leg-report.model.js';
import { LegApiModel } from './leg.api-model.ts';

export default class LegReportApiModel {
  public id!: number;
  public participationId!: number;
  public legId!: number;
  public leg: LegApiModel | undefined;
  public numberOfStudents!: number;
  public score!: number;
  public sickDays!: number;
  public studyDays!: number;
  public completedExercises!: string[];

  public static mapToBusinessModel(apiModel: LegReportApiModel): ILegReport {
    return {
      id: apiModel.id,
      participationId: apiModel.participationId,
      legId: apiModel.legId,
      leg: apiModel.leg ? LegApiModel.mapToBusinessModel(apiModel.leg) : undefined,
      numberOfStudents: apiModel.numberOfStudents,
      score: apiModel.score,
      sickDays: apiModel.sickDays,
      studyDays: apiModel.studyDays,
      completedExercises: apiModel.completedExercises,
    };
  }
}
